import { Logger } from 'winston'
import { buildDevLogger } from './dev-logger'
import { buildProdLogger } from './prod-logger'

const DEVELOPMENT_ENV = process.env.NODE_ENV === 'development'

let logger: Logger

if (DEVELOPMENT_ENV) {
  logger = buildDevLogger()
} else {
  logger = buildProdLogger()
}

export { logger }
